/*
 * Constants
 * Saved constants with dynamic Keys
 * To be used as actions at various events
 * Example: Status codes for ajax requests "no_auth_login" for non-logged in user
 *
 * @author: Chiran Doshi and Elton Jain
*/

define('modules/common/Constants',[], function () {
    "use strict";
    
    return {
        status_code: {
            no_auth_login: 'no_auth_login',
            no_auth_group: 'no_auth_group'
        },
        limits: {
        	activity_limit: 10,
        	notification_limit: 10,
        	report_limit: 5,
            user_limit: 10
        }
    };
});
